module.exports = __webpack_public_path__ + "static/img/TZ.b369e088.svg";